
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ticketsbundles",
      function () {
        return require("private-next-pages/ticketsbundles/index.tsx");
      }
    ]);
  